import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import { Bike } from 'redux/bikeCatalog/bikeCatalogTypes'

export const NON_DIRECT_CHECKOUT_VENDORS = ['WOMBI', 'RYBIT']

const VENDOR_DISPLAY_NAMES: Record<string, string> = {
  RIDEPANDA: 'RidePanda',
  WOMBI: 'Wombi',
  RYBIT: 'Rybit',
}

const StepsList = styled.ol`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin: 0;
  padding-left: 1.25rem;
  color: ${palette.text.primary};

  li {
    ${(props) => props.theme.typography.body2};
    padding-left: 0.25rem;
  }

  li::marker {
    ${(props) => props.theme.typography.body2};
  }
`

export const isNonDirectCheckoutVendor = (vendor?: string | null) => {
  return Boolean(vendor && NON_DIRECT_CHECKOUT_VENDORS.includes(vendor))
}

export const formatVendorName = (vendor?: string | null) => {
  if (!vendor) {
    return 'vendor'
  }

  if (VENDOR_DISPLAY_NAMES[vendor]) {
    return VENDOR_DISPLAY_NAMES[vendor]
  }

  return vendor
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

interface NonDirectCheckoutHelperProps {
  bike: Bike
}

const NonDirectCheckoutHelper = React.memo(
  (props: NonDirectCheckoutHelperProps) => {
    const { bike } = props
    const vendorName = formatVendorName(bike.vendor)

    return (
      <>
        <Text variant='body1'>
          We&apos;ll take you to {vendorName}&apos;s site to finish your order. A
          couple of things to know:
        </Text>
        <StepsList>
          <li>
            <Text variant='body2'>
              Select the {bike.name} and add any accessories you require - your
              employer&apos;s subsidy is already applied at {vendorName}{' '}
              checkout, add your personal card for any overages.
            </Text>
          </li>
          <li>
            <Text variant='body2'>
              {vendorName} will send you next steps and delivery details
              directly.
            </Text>
          </li>
        </StepsList>
      </>
    )
  }
)

if (process.env.NODE_ENV !== 'production') {
  NonDirectCheckoutHelper.displayName = 'NonDirectCheckoutHelper'
}

export default NonDirectCheckoutHelper
